import { UserDTO } from './../common/models/user.model';
import { atom } from "recoil";

export const AtomUsers = atom<UserDTO[]>({
    key: "atomUsers",
    default:[]
})